export default __webpack_public_path__ + "static/media/cbc-radio-canada-white-blanc.bfed7082.svg";